import React from 'react'

function RfcGlobal({ setRfc }) {


    function setRfcPrev(val) {

        //console.log( "Rfc = " + val.target.value)
    
        setRfc(val.target.value)
    }

  return (
    <div className='row align-items-center mt-5 mb-4'>


    <div className='col-6'>
      <div className="form-group">
        <label className={"estilo_label"}
          htmlFor="rfc">RFC</label>
        <input type="text" onChange={(val) => setRfcPrev(val )}
          className={"form-control  border-0 border-bottom border-end estilo_input"}
          id="rfc"
          title='Rfc' />

      </div>
    </div>

    <div className='col-6 text-center'>

      <div className='form-group w-100 ' style={{marginTop:'38px'}}>
        <button type='submit' className='btn btn-primary btn-block rounded-0'
          style={
            {
              width: '100%',
              position: 'relative',
              background: '#fBfBfB',
              color: '#0171E3',
              border: '1px solid #',
              padding: '8px 16px',
              transition: 'all 0.3s ease',
              overflow: 'hidden',
              marginTop: "35px"
            }
          }
          onMouseOver={
            (e) => {
              e.target.style.border = '1px solid #c0c0c0';
              e.target.style.color = '#c0c0c0';
            }
          }
          onMouseOut={
            (e) => {
              e.target.style.border = '1px solid #007bff';
              e.target.style.color = '#007bff';
            }
          }>Finalizar</button>
        </div >
    </div>

</div>

  )
}

export default RfcGlobal